import { render } from "./OrdersManage.vue?vue&type=template&id=388aa299&scoped=true"
import script from "./OrdersManage.vue?vue&type=script&lang=js"
export * from "./OrdersManage.vue?vue&type=script&lang=js"

import "./OrdersManage.vue?vue&type=style&index=0&id=388aa299&lang=css"
import "./OrdersManage.vue?vue&type=style&index=1&id=388aa299&scoped=true&lang=css"
import "./OrdersManage.vue?vue&type=style&index=2&id=388aa299&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388aa299"]])

export default __exports__